import { MAP_OVERLAYS } from "~/state/map/constants";
import { store } from "~/state/store";
import { watch, watchMap } from "~/state/util";
import { isDetailActive } from "~/util/detail";

interface IAnyObject {
	[key: string]: string | number | object | Array<number | string>;
}

interface IData {
	myGallery?: boolean;
	fromDC?: boolean;
	like?: any;
	type?: string;
	analytics?: {
		[key: string]: string | number | Array<number | string>;
	}
}

interface IGalleryData {
	galleryType: string;
	section: string;
	ratio: number;
}

export function analyticsLog(data: IData, params: IAnyObject, action = "click") {
	const galleryData: IGalleryData = Mapy.getComponent("gallery").isActive() ? Mapy.getComponent("gallery").logData : {};
	let logData: {
		section?: string;
		galleryType?: string;
		itemType?: string;
		type?: string;
		origin?: string;
		place?: string;
	} = {};

	if (data.myGallery) {
		logData = {
			section: "gallery",
			galleryType: galleryData.galleryType ? galleryData.galleryType : "photomap",
		};
	}

	if ("fromDC" in data && data.fromDC && !data.like) {
		logData[action === "iframe" ? "itemType" : "type"] = "map";
		logData.origin = "web";
	} else if ("type" in data && data.type) {
		logData[action === "iframe" ? "itemType" : "type"] = data.type;
		logData.origin = data.like || data.myGallery || Mapy.getComponent("mymaps").isActive() ? "my_maps" : "web";
	}

	if (Mapy.getComponent("photoDetail").isActive()) {
		logData.place = "detail";
	}

	Mapy.getComponent("logger").log(action, {
		...galleryData,
		...logData,
		...params,
		...data.analytics ? data.analytics : {},
	});
}

function getActiveComponentType() {
	const obj:{
		type?: string;
	} = {};

	const state = store.getState();

	if (isDetailActive(state)) {
		obj.type = state.detail.source === "coor" ? "point" : "entity";
	} else if (Mapy.getComponent("route").isActive() && Object.keys(Mapy.getComponent("route").getState())) {
		obj.type = "route";
	} else if (Mapy.getComponent("userMarks").isActive() && Mapy.getComponent("userMarks").getState().uc) {
		obj.type = "set";
	} else if (Mapy.getComponent("distanceMeter").isActive() && Mapy.getComponent("distanceMeter").getState().rm) {
		obj.type = "measure";
	}

	return obj;
}

export function iframeAnalyticsLog(params: IAnyObject, action = "iframe") {
	const componentType = getActiveComponentType();
	const activitiesData = Mapy.getComponent("activities").shareData;
	const placesData = Mapy.getComponent("places").shareData;
	const dimcuratorData = Mapy.getComponent("dimcurator").getLikeData();
	const data = {
		...componentType,
		...activitiesData?.id ? activitiesData : {},
		...placesData?.id ? placesData : {},
		...dimcuratorData?.id
			? {
				like: true,
				...dimcuratorData,
			}
			: {},
	};

	analyticsLog(data, params, action);
}

// cas, ktery resetujeme vzdy, kdyz se zmeni mapset nebo overlaye, protoze je
let mapsetDate = new Date();

// sledovani zmen mapsetu a overlayu, abychom prenastavili cas posledni zmeny
const wt = watch(store.getState, "map", watchMap);

store.subscribe(wt((newMapState, oldMapState) => {
	const newOverlaysCount = newMapState.mapset in newMapState.currentOverlays ? newMapState.currentOverlays[newMapState.mapset].length : 0;
	const oldOverlaysCount = oldMapState.mapset in oldMapState.currentOverlays ? oldMapState.currentOverlays[oldMapState.mapset].length : 0;

	// zmenil se mapset, nebo nejak overlaye
	if (newMapState.mapset !== oldMapState.mapset || newOverlaysCount !== oldOverlaysCount) {
		mapsetDate = new Date();
	}
}));

const OVERLAY_TO_STRING = {
	[MAP_OVERLAYS.CADASTRAL]: "katastr",
	[MAP_OVERLAYS.PHOTO]: "foto",
	[MAP_OVERLAYS.HILLSHADE]: "sklon",
	[MAP_OVERLAYS.WEBCAM]: "webcam",
	[MAP_OVERLAYS.TURIST]: "turist",
	[MAP_OVERLAYS.TRAFFIC]: "doprava",
	[MAP_OVERLAYS.SKI]: "bezky",
	[MAP_OVERLAYS.PANORAMA]: "pano",
};

function overlaysToString(overlays: Array<MAP_OVERLAYS>): string {
	return overlays.sort().map(overlay => OVERLAY_TO_STRING[overlay]).join("-");
}

// pri zavreni stranky zkusime poslat jeste jednu analytiku (ale vime, ze se to nemusi povest)
window.addEventListener("beforeunload", () => {
	const state = store.getState().map;
	const overlays = state.mapset in state.currentOverlays ? [...state.currentOverlays[state.mapset]] : [];

	Mapy.getComponent("logger").log("mapset_duration", {
		overlays: overlaysToString(overlays),
		duration: Math.floor((new Date().getTime() - mapsetDate.getTime()) / 1000),
	});
});

interface IChmapLogParams {
	mapset?: string;
	mapsetNew: string;
	overlays: Array<MAP_OVERLAYS>;
	overlaysNew: Array<MAP_OVERLAYS>;
	overlayAdd?: MAP_OVERLAYS;
	overlayRemove?: MAP_OVERLAYS;
	type?: string;
}

export function chmapLog({
	mapset,
	mapsetNew,
	overlays,
	overlaysNew,
	overlayAdd,
	overlayRemove,
	type,
}: IChmapLogParams) {
	Mapy.getComponent("logger").log("chmap", {
		mapsetNew,
		overlaysNew: overlaysToString(overlaysNew),
		overlays: overlaysToString(overlays),
		overlaysNewCount: overlaysNew.length,
		duration: Math.floor((new Date().getTime() - mapsetDate.getTime()) / 1000),
		...overlayAdd ? { overlayAdd: OVERLAY_TO_STRING[overlayAdd] } : {},
		...overlayRemove ? { overlayRemove: OVERLAY_TO_STRING[overlayRemove] } : {},
		...type ? { type } : {},
		...mapset ? { mapset } : {},
	});
}
